module.exports = __webpack_public_path__ + "static/media/first.5e0d3cc6.svg";